import VuexORM from '@vuex-orm/core'

import { Anesthesiology } from '../models/Anesthesiology'
import { NeurosurgeryProcedure } from '../models/Neurosurgery'
import Pathology from '../models/Pathology'
import Neuroradiology from '../models/Neuroradiology'
import { GeneralSurgery } from '../models/GeneralSurgery'
import Specialty, {
  Logbook,
  LogbookComponent,
  Section,
  Component,
  Option,
  Internship,
  FamilyMedicine,
  TreeDataDictionary,
  LogbookComponentConditions,
  OptionDiagnosisPathology,
  OrganSystem2Pathology
} from '../models/Specialty'
import {
  PathologyDiagnosis,
  OrganSystem,
  LesionType,
  Organ
} from '../models/Pathology'
import {
  Supervisor,
  Hospital,
  HealthCenterGroup,
  Sponsors,
  InternshipsSpecialty,
  AgeOption
} from '../models/Content'
import {
  DiagnosisQualifiers,
  Malignancy,
  SurgeryDiagnosis,
  SurgeryProcedure
} from '../models/GeneralSurgery'
import { ICPC, ICPCChapter, ICPCComponent } from '../models/FamilyMedicine'
import { DrugClass, DrugTree } from '../models/Drugs'

import { ActivityLogbook, SubComponent } from '@/models/ScientificActivity'
import { TrainningLogbook } from '@/models/TrainningActivity'
import {
  Orthopedics,
  AnatomicRegion,
  OrthopedicDiagnosis,
  OrthopedicProcedure,
  TraumaDiagnosis,
  TraumaProcedure
} from '../models/Orthopedics'
import { ICDOCode, Oncology } from '../models/Oncology'
import { ICD10Code, Rheumatology } from '../models/Rheumatology'
import { InternalMedicine } from '../models/InternalMedicine'
import { CoordinatedUsers } from '../models/CoordinatedUsers'
import { SharedUsers } from '../models/SharedUsers'
import { UsersIdInfo } from '../models/UsersInfo'

export default function database() {
  const database = new VuexORM.Database()

  database.register(TreeDataDictionary)
  database.register(Specialty)
  database.register(Anesthesiology)
  database.register(Logbook)
  database.register(LogbookComponent)
  database.register(LogbookComponentConditions)
  database.register(OptionDiagnosisPathology)
  database.register(OrganSystem2Pathology)
  database.register(Section)
  database.register(Component)
  database.register(Option)
  database.register(Internship)

  database.register(DrugClass)
  database.register(DrugTree)

  database.register(Pathology)
  database.register(PathologyDiagnosis)
  database.register(OrganSystem)
  database.register(Organ)
  database.register(LesionType)

  database.register(FamilyMedicine)
  database.register(ICPC)
  database.register(ICPCChapter)
  database.register(ICPCComponent)

  database.register(Neuroradiology)

  database.register(GeneralSurgery)
  database.register(DiagnosisQualifiers)
  database.register(Malignancy)
  database.register(SurgeryDiagnosis)
  database.register(SurgeryProcedure)

  database.register(Supervisor)
  database.register(Hospital)
  database.register(HealthCenterGroup)
  database.register(Sponsors)
  database.register(InternshipsSpecialty)
  database.register(AgeOption)
  database.register(CoordinatedUsers)
  database.register(SharedUsers)
  database.register(UsersIdInfo)

  database.register(ActivityLogbook)
  database.register(TrainningLogbook)
  database.register(SubComponent)

  database.register(Orthopedics)
  database.register(AnatomicRegion)
  database.register(OrthopedicDiagnosis)
  database.register(OrthopedicProcedure)
  database.register(TraumaDiagnosis)
  database.register(TraumaProcedure)
  database.register(Oncology)
  database.register(ICDOCode)
  database.register(Rheumatology)
  database.register(ICD10Code)
  database.register(InternalMedicine)
  database.register(NeurosurgeryProcedure)
  return database
}
